import { Component, OnDestroy } from '@angular/core';
import { SearchParams } from '../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../shared/search/models/search-status.model';
import { SearchService } from '../../../shared/search/search.service';
import { DetailedEntityDataService } from '../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SimpleEntityDataService } from '../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { SharedServiceRegistry } from '../../../shared/shared-service-registry';

@Component({
    selector: 'lfwms-help-popup',
    templateUrl: './help-popup.component.html',
    styleUrls: ['./help-popup.component.css']
})

export class HelpPopupComponent {

    protected dataService: DetailedEntityDataService;
    protected dataService1: SimpleEntityDataService;

    public isLoading: boolean = true;
    public searchService: SearchService;
    private searchParams: SearchParams;
    private searchStatus: SearchStatus;
    public data: any[] = [];
    public defaultError: boolean = false;

    constructor(private sharedServiceRegistry: SharedServiceRegistry) {
    }

    public initialize() {
        this.searchParams = new SearchParams();
        const helpTableIds: any = JSON.parse(localStorage.getItem('HELPTABLEIDS'));
        if (helpTableIds) {
            if (helpTableIds.length > 0) {
                helpTableIds.forEach(tableId => {
                    this.searchParams.tableId = tableId;
                    this.searchParams.isFullFetch = true;
                    this.searchStatus = new SearchStatus();
                    this.searchService = this.sharedServiceRegistry
                        .createSearchService(this.searchParams, this.searchStatus);
                    this.searchService.fetchMetadata().subscribe((res) => {
                        this.data = [...this.data, ...res.columnList];
                        this.isLoading = false;
                    });
                });
            }
        } else {
            this.defaultError = true;
        }
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/help-popup/help-popup.component.ts